"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./DmsServicesCardSection.module.css";
import ServiceCard from "../../components/ServiceCard";
import dmsServicesData from "../../data/document-management-system";

export default function DmsServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;
  const displayData = services?.items || dmsServicesData;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="text-center mb-4" data-reveal="slide-up">
          <div className={styles.eyebrow}>{services?.title || "DOCUMENT MANAGEMENT SYSTEM"}</div>
          <h2 className={styles.title}>{services?.subtitle || "DMS Services We Provide"}</h2>
        </div>
        <div className="row g-3 g-md-4" data-reveal="stagger-up">
          {displayData.map((card) => (
            <div className="col-12 col-md-6 col-lg-4" key={card.title}>
              <ServiceCard
                title={card.title}
                description={card.description}
                bullets={card.bullets} tags={card.tags}
                minHeight={card.minHeight}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
